"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageUtils = void 0;
const __1 = require("..");
const readable = (language) => {
    if (language === __1.ELanguage.en)
        return "English";
    if (language === __1.ELanguage.fr)
        return "French";
    if (language === __1.ELanguage.de)
        return "German";
    if (language === __1.ELanguage.nl)
        return "Dutch";
    if (language === __1.ELanguage.us)
        return "American English";
    return "";
};
exports.languageUtils = {
    readable,
};
//# sourceMappingURL=languageUtils.js.map